var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-good-table',{staticClass:"cargo-details mb-50",attrs:{"styleClass":"vgt-table bordered","theme":"polar-bear","columns":_vm.columns,"rows":_vm.rows,"group-options":{
        enabled: true
    },"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return undefined}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }